import { __awaiter, __generator } from "tslib";
var Bpoint = (function () {
    function Bpoint(_httpClient) {
        this._httpClient = _httpClient;
    }
    Bpoint.prototype.TokenizeCreditCard = function (authResponse, creditCard, customerRef) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this._httpClient.post(authResponse.actionUrl, {
                            DVTokenReq: {
                                Crn1: customerRef,
                                CardDetails: {
                                    CardHolderName: creditCard.cardHolderName,
                                    CardNumber: creditCard.cardNumber,
                                    ExpiryDateMonth: creditCard.expiryMonth,
                                    ExpiryDateYear: creditCard.expiryYear,
                                },
                            },
                        });
                        return [4, request];
                    case 1:
                        response = (_a.sent()).data;
                        if (response.APIResponse.ResponseCode !== 0) {
                            throw new Error(JSON.stringify(response.APIResponse));
                        }
                        return [2, {
                                redirectUrl: response.RedirectionUrl,
                                resultToken: response.ResultKey,
                            }];
                }
            });
        });
    };
    Bpoint.prototype.TokenizeBankAccount = function (authResponse, bankAccount, customerRef) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this._httpClient.post(authResponse.actionUrl, {
                            DVTokenReq: {
                                Crn1: customerRef,
                                AcceptBADirectDebitTC: true,
                                BankAccountDetails: {
                                    BSBNumber: bankAccount.bsb,
                                    AccountNumber: bankAccount.accNo,
                                    AccountName: bankAccount.accName,
                                },
                            },
                        });
                        return [4, request];
                    case 1:
                        response = (_a.sent()).data;
                        if (response.APIResponse.ResponseCode !== 0) {
                            throw new Error(JSON.stringify(response.APIResponse));
                        }
                        return [2, {
                                redirectUrl: response.RedirectionUrl,
                                resultToken: response.ResultKey,
                            }];
                }
            });
        });
    };
    Bpoint.prototype.TokenizeOw30DayAccount = function (_popup) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("Not Implemented");
            });
        });
    };
    return Bpoint;
}());
export { Bpoint };
//# sourceMappingURL=Bpoint.js.map